import { Invoice, InvoiceQueryParams } from '@ravago/shared/page-data/models/elements';
import { PaginatedResponse } from '@ravago/shared/page-data/models/elements/paginated-response.model';

import { BillingType } from '../models/billing-type.model';

export enum InvoiceAction {
   CLOSED_INVOICES_NOT_FOUND = 'CLOSED_INVOICES_NOT_FOUND',
   SET_BILLING_TYPE = 'SET_BILLING_TYPE',
   SET_CLOSED_INVOICES = 'SET_CLOSED_INVOICES',
   SET_CLOSED_INVOICES_QUERY_PARAMS = 'SET_CLOSED_INVOICES_QUERY_PARAMS'
}

export type SetBillingTypeAction = { type: InvoiceAction.SET_BILLING_TYPE; payload: BillingType };

export type SetClosedInvoicesAction = {
   type: InvoiceAction.SET_CLOSED_INVOICES;
   payload: PaginatedResponse<Invoice[]>;
};

export type SetClosedInvoicesQueryParamsAction = {
   type: InvoiceAction.SET_CLOSED_INVOICES_QUERY_PARAMS;
   payload: InvoiceQueryParams;
};

export type ClosedInvoicesNotFountAction = { type: InvoiceAction.CLOSED_INVOICES_NOT_FOUND };

export type Action = SetBillingTypeAction | SetClosedInvoicesAction | SetClosedInvoicesQueryParamsAction | ClosedInvoicesNotFountAction;
